import { Alert, Button, Stack, Typography } from '@mui/material';
import { useFieldArray, useForm } from "react-hook-form";
import StepperDUC from "./StepperDUC";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import SubRecipientInfoComponent from "./components/SubRecipientInfoComponent";
import { useCheckSubApplicantsMutation } from "../../api/ducApiSlice";
import { useEffect, useState } from "react";
import SubRecipientsErrorModal from "./components/SubRecipientsErrorModal";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { colours } from '../../StyleConstants';
import { Box } from '@mui/system';

interface FormValuesRecipient {
    subApplicants: {
        firstName: string
        lastName: string
        email: string
    }[]
}

const SubRecipients = (props: any) => {

    const [checkSub] = useCheckSubApplicantsMutation();
    const [openModal, setOpenModal] = useState(false);
    const [error, setError] = useState<string[]>([])
    const [ducId, setDucID] = useState(0);
    const [subRecipientsObj, setSubRecipientsObj] = useState<FormValuesRecipient>({ subApplicants: [] });
    const [firstRender, setFirstRender] = useState(false)


    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors },
    } = useForm<FormValuesRecipient>({
        defaultValues: {
            subApplicants: props?.DUCInfo?.subApplicants || props?.prevData?.data?.subApplicants || [{
                firstName: "",
                lastName: "",
                email: ""
            }]
        }
    });

    useEffect(() => {
        if(!props.prevData?.data){
            setFirstRender(true)
        }
        else if(props.prevData?.data && firstRender){
            setValue("subApplicants", props.prevData?.data?.subApplicants)

        }
    }, [props.prevData]);


    const { fields, append, remove } = useFieldArray({
        control,
        name: "subApplicants"
    })

    const handleClick = (newData: FormValuesRecipient) => {

        if(newData?.subApplicants?.length === 0){
            setError(["You need to add at least one Sub-Applicant to continue"])
            setOpenModal(true)
            return
        }

        setDucID(props?.data?.ducDetailsId)

        setSubRecipientsObj(newData)
    }


    const handleClickBack = () => {
        props.setCurStep(props.curStep - 1)
    }

    const handleClickAdd= () => {
        append({
            firstName: "",
            lastName: "",
            email: ""
        })
    }

    const handleClickRemove = (id: number) => {
        remove(id)
    }



    const checkIfNew = (email: string, index: number) => {
        const subApp = props?.prevData?.data?.subApplicants

        if (props.isAddSub && subApp) {
            if(!props.DUCInfo?.firstName){
                props.setDUCInfo({ ...props.DUCInfo, city: props?.prevData?.data?.city, country: props?.prevData?.data?.country,
                    state: props?.prevData?.data?.state, degree: props?.prevData?.data?.degree, email: props?.prevData?.data?.email,
                    firstName: props?.prevData?.data?.firstName, institution: props?.prevData?.data?.institution,
                    lastName: props?.prevData?.data?.lastName, phone: props?.prevData?.data?.phone,
                    statement: props?.prevData?.data?.statement })
            }


            if(fields.findIndex((field) => field.email === email) < index){
                return true
            }

            return !(subApp.findIndex((sub: { email: string; }) => sub.email === email) + 1);


        }
        else if (props.isEdit && props.isSecond && subApp){

            const index = subApp.findIndex((sub: { email: string; }) => sub.email === email)
            if(index !== -1){
                return subApp[index]?.newlyAddedUser
            }

            return true
        }
        return true
    }


    useEffect(() => {

        if(subRecipientsObj && subRecipientsObj.subApplicants.length !== 0 && (props.edit === true ? ducId !== 0 : true)){

            if((JSON.stringify(subRecipientsObj?.subApplicants) === JSON.stringify(props?.prevData?.data?.subApplicants))
            && props.isAddSub){
                setError(["You need to add at least one new Sub-Applicant to continue"])
                setOpenModal(true)
                return
            }

            checkSub({ data: { ...props.DUCInfo, ...subRecipientsObj, "ducDetailsId": ducId } }).then((response: any) => {
                if(response?.data === null){
                    props.setDUCInfo({ ...props.DUCInfo, ...subRecipientsObj });

                    props.setCurStep(props.curStep + 1)
                }
                else if (response.error && "data" in response.error && response.error.data?.errors ) {
                    setError(response.error.data?.errors)
                    setOpenModal(true)
                }
            })
        }

    }, [ducId, subRecipientsObj]);

    return (
        <Stack flexDirection="column" gap={3}>
            <Stack flexDirection="column" gap={4}>
                <StepperDUC
                    activeStep={props.curStep}
                    stepLabels={props.stepLabels} />
            </Stack>
            <Stack alignItems={"flex-start"} gap={4}>
                <Box>
                    <Typography variant={"h2"} fontSize={"20px"} fontWeight={"bold"}>Sub-applicants</Typography>
                    <Typography fontSize={"14px"}>List all sub-applicants that require data use access.
                        Sub-applicants will not need to fill or sign individual request. Each sub-applicant will have to complete training after approval.
                    </Typography>
                </Box>

                <Alert
                    icon={<InfoOutlinedIcon
                        fontSize="inherit"
                        sx={{ color: colours.notifications.info }} />}
                    sx={{ backgroundColor: colours.notifications.info10 }
                    }
                >
                    <Typography fontSize={"14px"}><strong>Sub-applicants must be affiliated with your own institution.</strong></Typography>
                </Alert>

                {(props.isAddSub || (props.isEdit && props.isSecond)) &&
                  <Typography textAlign={"center"} fontSize={"15px"}>
                      <strong> Previously approved sub-applicants can only be removed through the Investigator Dashboard </strong>
                  </Typography>
                }
            </Stack>


            <Stack flexDirection="column" gap={4}>
                <Stack overflow="auto" gap={4} height="500px">
                    {fields.map((field, index) => {
                        const disabled = !checkIfNew(getValues()?.subApplicants?.[index]?.email, index)
                        return (
                            <Stack key={`field-${index}`} flexDirection="column" gap={4}>
                                <Stack flexDirection="row" gap={1}>
                                    {!disabled &&
                                        <RemoveCircleOutlineIcon
                                            onClick={() => {handleClickRemove(index)}}/>}

                                    <Typography
                                        variant="h2"
                                        fontSize="20px"
                                        fontWeight="600"
                                    >
                                        Sub-Applicant {index + 1}
                                    </Typography>
                                </Stack>

                                <SubRecipientInfoComponent
                                    id={index}
                                    key={field.id}
                                    disabled={disabled}
                                    control={control}
                                    errors={errors.subApplicants}/>
                            </Stack>)
                    })}
                </Stack>
                <Button
                    id={"duc-subrecipients-add-new-sub-applicant-button"}
                    variant="primary"
                    onClick={handleClickAdd}
                    sx={{ alignSelf: "center" }}
                >
                    Add new Sub-applicant
                </Button>
            </Stack>


            <Stack
                flexDirection="row"
                justifyContent="space-between">

                <Button
                    id={"duc-flow-back-button"}
                    variant="tertiary"
                    onClick={handleClickBack}
                    sx={{ alignSelf: "center" }}
                >
                    Back
                </Button>

                <Button
                    id={"duc-flow-continue-button"}
                    variant="primary"
                    onClick={handleSubmit(handleClick)}
                    sx={{ alignSelf: "center" }}
                >
                    Continue
                </Button>

                <SubRecipientsErrorModal error={error} open={openModal} setOpen={setOpenModal}/>

            </Stack>

        </Stack>

    )

}

export default SubRecipients;
